import { classNames, useEffect, useQuery, useState } from 'libs/react';
import { QuoteHeaderMenu } from './QuoteHeaderMenu';
import { Button } from 'components/Button';
import { ButtonGroup } from 'components/ButtonGroup';
import { Image } from 'components/Image';
import { React } from 'libs/react';
import { QuoteHeaderInfo } from './QuoteHeaderInfo';
import { useModal } from 'components/modal/ModalStack';
import { MediaType } from 'libs/media/MediaType';
import { SelectorMediasQuery } from 'components/media/form/FormMediaSelector';
import './QuoteHeader.scss';
/**
 * @component QuoteHeader
 * @since 1.0.0
 */
export function QuoteHeader(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    const { data, hasApproval, hasPaymentProcess, hasDeposit } = props;
    const isAgreement = data.type === 'AGREEMENT';
    const isSigned = data.status === 'WON' || data.status === 'SIGNED';
    const canAccept = hasApproval === 'TRUE' &&
        (data.canBeSigned || data.directSale || isAgreement) &&
        !isSigned &&
        data.status !== 'LOST' &&
        data.status !== 'INACTIVE' &&
        (isAgreement || data.priceDisplay !== 'NONE');
    const modal = useModal();
    const [file, setFile] = useState(null);
    const clientLogo = (_b = (_a = data.client) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.url;
    const contactLogo = (_d = (_c = data.contact) === null || _c === void 0 ? void 0 : _c.image) === null || _d === void 0 ? void 0 : _d.url;
    const hasLogo = clientLogo || contactLogo;
    const headerLogo = ((_f = (_e = data.partner) === null || _e === void 0 ? void 0 : _e.image) === null || _f === void 0 ? void 0 : _f.url) ||
        ((_k = (_j = (_h = (_g = data.user) === null || _g === void 0 ? void 0 : _g.contact) === null || _h === void 0 ? void 0 : _h.client) === null || _j === void 0 ? void 0 : _j.image) === null || _k === void 0 ? void 0 : _k.url) ||
        ((_o = (_m = (_l = data.user) === null || _l === void 0 ? void 0 : _l.account) === null || _m === void 0 ? void 0 : _m.logo) === null || _o === void 0 ? void 0 : _o.url) ||
        '/images/menu-bar-logo-icon.svg';
    const value = ((_q = (_p = data.fieldValues) === null || _p === void 0 ? void 0 : _p.find((field) => field.field.name === 'clubpiscine.your_quote')) === null || _q === void 0 ? void 0 : _q.value)
        ? JSON.parse((_s = (_r = data.fieldValues) === null || _r === void 0 ? void 0 : _r.find((field) => field.field.name === 'clubpiscine.your_quote')) === null || _s === void 0 ? void 0 : _s.value).value
        : null;
    const [fileData, ready] = useQuery(SelectorMediasQuery, {
        skip: value == null || (Array.isArray(value) && value.length === 0),
        variables: {
            selectedInput: {
                query: {
                    field: 'ids',
                    value: value,
                    operator: 'IN'
                }
            },
            input: {
                query: {
                    field: 'ids',
                    value: Array.isArray(value) ? value.join() : value,
                    operator: 'IN'
                }
            }
        }
    });
    useEffect(() => {
        if (ready && (fileData === null || fileData === void 0 ? void 0 : fileData.selectedMedias)) {
            setFile(fileData.selectedMedias[0] || null);
        }
    }, [fileData, ready]);
    /**
     * @function onQuotePDF
     * @since 1.0.0
     * @hidden
     */
    const onQuotePDF = () => {
        if (!file) {
            return;
        }
        const isImage = MediaType.isImage(file.mimetype);
        const isPdf = MediaType.isFile(file === null || file === void 0 ? void 0 : file.mimetype);
        modal.present({
            title: file === null || file === void 0 ? void 0 : file.filename,
            picto: '',
            className: classNames('quote-media-modal', isImage ? 'quote-media-modal--image' : '', isPdf ? 'quote-media-modal--pdf' : ''),
            modal: (React.createElement("div", { className: "quote-media-modal-file" }, isImage ? (React.createElement("img", { src: file === null || file === void 0 ? void 0 : file.url, alt: file === null || file === void 0 ? void 0 : file.filename })) : (React.createElement("embed", { src: file === null || file === void 0 ? void 0 : file.url, width: "100%", height: "100%" }))))
        });
    };
    const className = classNames('quote-header', props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "quote-header-main" },
            React.createElement("div", { className: "quote-header-head" },
                React.createElement(Image, { eager: true, className: "quote-header-logo", source: headerLogo, onClick: () => {
                        const element = document.getElementById('quote-view-banner');
                        if (element) {
                            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    } })),
            React.createElement("div", { className: "quote-header-body" },
                React.createElement(QuoteHeaderInfo, { data: data })),
            React.createElement("div", { className: "quote-header-foot" },
                React.createElement(ButtonGroup, { className: "quote-header-actions" },
                    canAccept && (React.createElement(Button, { className: "quote-header-action-approve", picto: hasPaymentProcess
                            ? 'money-check-dollar-pen'
                            : 'circle-check', label: hasPaymentProcess
                            ? hasDeposit
                                ? t('Accept and pay deposit')
                                : t('Accept and pay')
                            : t('Accept'), onPress: props.onApprove })),
                    data.status === 'LOST' ? (React.createElement(Button, { className: "quote-header-action-approve is-refused", picto: "xmark-circle", label: t('Refused'), disabled: true })) : data.directSale && data.status === 'WON' ? (React.createElement(Button, { className: "quote-header-action-approve", picto: "money-check-dollar-pen", label: t('Approved'), onPress: props.onApprove })) : (hasApproval === 'TRUE' &&
                        isSigned && (React.createElement(Button, { className: "quote-header-action-approve is-approved", picto: "fad circle-check", label: t('Signed'), onPress: props.onApprove }))),
                    ((_u = (_t = data.user) === null || _t === void 0 ? void 0 : _t.account) === null || _u === void 0 ? void 0 : _u.tag) === 'clubpiscine' && file && (React.createElement(Button, { className: "quote-header-action-approve", picto: "file-pdf", label: t('View Quote PDF'), onPress: onQuotePDF })))),
            React.createElement("div", { className: "quote-header-side" },
                React.createElement("div", { className: "quote-header-client-logo--mobile" }, hasLogo ? (React.createElement(Image, { className: "quote-header-contact-logo", source: clientLogo })) : contactLogo ? (React.createElement(Image, { className: "quote-header-contact-logo", source: contactLogo })) : null),
                React.createElement(QuoteHeaderMenu, { data: data, hasApproval: hasApproval, onDiscuss: props.onDiscuss }),
                canAccept && (React.createElement(Button, { className: "quote-header-action-approve--mobile", picto: hasPaymentProcess ? 'money-check-dollar-pen' : 'circle-check', style: "picto", onPress: props.onApprove })),
                data.status === 'LOST' ? (React.createElement(Button, { className: "quote-header-action-approve--mobile is-refused", picto: "xmark-circle", style: "picto", disabled: true })) : data.directSale && data.status === 'WON' ? (React.createElement(Button, { className: "quote-header-action-approve--mobile", picto: "money-check-dollar-pen", style: "picto", onPress: props.onApprove })) : (hasApproval === 'TRUE' &&
                    isSigned && (React.createElement(Button, { className: "quote-header-action-approve--mobile is-approved", picto: "fad circle-check", style: "picto", onPress: props.onApprove }))),
                ((_w = (_v = data.user) === null || _v === void 0 ? void 0 : _v.account) === null || _w === void 0 ? void 0 : _w.tag) === 'clubpiscine' && file && (React.createElement(Button, { className: "quote-header-action-approve--mobile", picto: "file-pdf", style: "picto", onPress: onQuotePDF }))))));
}
